import React, { useEffect, useState } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { Card, Accordion, Form, InputGroup } from "react-bootstrap";

import TutorialPopup from "../../help/TutorialPopup";
import * as HelpContent from "../../../utils/HelpContent";
import { CHANGE_FUND, CHANGE_ORDER_TYPE } from "../../../actions/create-bot-type";
import { isLong } from "../../../utils/Utils";
import { formatNumberToString } from "../../../utils/Utils";
import NormalParamsView from "./normal-bot/NormalParamsView";
import { BotType, CreateBotModules, OrderTypeModule } from "../../../Const";
import DcaParamsView from "./dca-bot/DcaParamsView";
import PriceBotParamsView from "./price-bot/PriceBotParamsView";
import BooleanView from "./BooleanView";
import { FUND_ALLOCATION } from "../../../actions/types";
import SellBotParamsView from "./sell-bot/SellBotParamsView";
import QuickStartBotParamsView from "./quick_start/QuickStartBotParamsView";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const TradeParamsView = (props) => {
  const { newBot, editing,t } = props;
  const fund = newBot.initFund;
  const isSellBot = newBot.botType == BotType.sell
  const strategy = isSellBot?"Short":newBot.strategy
  const selectedExchange = newBot.exchange;
  const currentCoin = isLong(strategy)
    ? newBot.quoteCoin
    : newBot.baseCoin;
  const balances = useSelector((state) => state.bots.balances);
  const balance =
    balances && balances.find((item) => item.coin === currentCoin);
  const pairData = useSelector((state) => state.bots.pairData);
  const pairMarginLevels = newBot.pairMarginLevels;
  const [marginLevel,setMarginLevel] = useState(pairMarginLevels?pairMarginLevels[0] && pairMarginLevels[0].percentage:0)
  const dispatch = useDispatch();
  const getParamsView = ()=>{
    switch (newBot.botType) {
      case BotType.dca:
        return <DcaParamsView newBot={newBot} currentCoin={currentCoin} t={t}/>
      case BotType.price :
        return <PriceBotParamsView newBot={newBot} t={t}/>
      case BotType.sell :
        return <SellBotParamsView newBot={newBot} t={t}/>
      case BotType.quick_start :
      return <QuickStartBotParamsView newBot={newBot} t={t}/>
      default:
        return <NormalParamsView newBot={newBot} t={t} />
    }
  }
  useEffect(() => {
    if (balance && !editing) {
      //fundChanged(parseFloat(balance.free).toFixed(2));
    }
  }, [balance]);
  
  const fundChanged = (val) => {
    dispatch({
      type: CHANGE_FUND,
      payload: val,
    });
    if(pairMarginLevels){
      for (var i=0; i < pairMarginLevels.length;i++){
        var item = pairMarginLevels[i]
        if(val < item.quantity){
          setMarginLevel(i>0?pairMarginLevels[i-1].percentage:pairMarginLevels[i].percentage)
          break;
        }
        setMarginLevel(pairMarginLevels[i].percentage)
       //console.log("marginLevel",item)
      }
      
      
    }
  };
  const orderTypeChanged = (orderType) => {
    dispatch({
      type: CHANGE_ORDER_TYPE,
      payload: orderType,
    });
  };

  return (
    <>
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="1">
          <span className="trade-params-tour">2. {t("t-params")}</span>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="1">
          <Card.Body>
          {!newBot.dcaNoLimitFund   && (
            <>
            <Form.Group>
              <Form.Label>
              { isSellBot?t("amount-to-sell"):<>{t("fund-alloc")}<TutorialPopup content={t("initFund-help")} /></> }
                
              </Form.Label>
                  <Form.Control
                      as="input"
                      type="number"
                      placeholder="1000"
                      value={fund}
                      onChange={(e) => {
                        fundChanged(e.target.value);
                      }}
                    ></Form.Control>
              {/* <p style={{ fontSize: 13, marginTop: 10 }}>
                {t("available")}: {formatNumberToString(balance && balance.free)}{" "} 
                {currentCoin} {" "} {selectedExchange.id==0 &&  <Link to="/setting?loc=5"><i className="fas fa-sliders-h" style={{fontSize:"15px",marginLeft:"10px"}}></i></Link>}
              </p> */}
              <p style={{ fontSize: 13, marginTop: 2 }}>Min Quantity : {newBot.minQuantity}</p>
              <p style={{ fontSize: 13, marginTop: 10 }}>
                {t("Margin Required")}: {(fund * marginLevel)/100} {" "}{pairData && pairData.funds && pairData.funds.coin} &nbsp;
                {t("available")}: {formatNumberToString(pairData && pairData.funds && pairData.funds.tradableFunds,2 )}{" "} 
                {pairData && pairData.funds && pairData.funds.coin} {" "} {selectedExchange.id==0 &&  <Link to="/setting?loc=5"><i className="fas fa-sliders-h" style={{fontSize:"15px",marginLeft:"10px"}}></i></Link>}
              </p>
            </Form.Group>
            </> )}
            {(OrderTypeModule[newBot.botType]) && (
            <div style={{ marginTop: 20 }}>
            <BooleanView
                title={t("order-type")}
                firstButton="limit"
                secondButton="market"
                selected={newBot.tradeOrderType}
                onSelect={orderTypeChanged}
                tutorial={<TutorialPopup content={t("orderType")} />}
              />
            </div>
            )}
            {getParamsView()}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
};

export default connect(null)(TradeParamsView);
